import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { captureUtm } from './utils/attribution';

// Remember the utm tags of the link the visitor came in on (consultation forms send them).
captureUtm();


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);


